import { render, staticRenderFns } from "./metrics_student_action_plan.vue?vue&type=template&id=20ce7fba&scoped=true&"
import script from "./metrics_student_action_plan.vue?vue&type=script&lang=js&"
export * from "./metrics_student_action_plan.vue?vue&type=script&lang=js&"
import style0 from "./metrics_student_action_plan.vue?vue&type=style&index=0&id=20ce7fba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ce7fba",
  null
  
)

export default component.exports